// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Numeral = require("../../../utils/Numeral.bs.js");
let NumberUtils = require("../NumberUtils.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let WizardFormUtils = require("../../client/wizard/WizardFormUtils.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let DevelopmentSampleUnitType = require("./DevelopmentSampleUnitType.bs.js");

function title(unitType, name) {
  let name$1 = WizardFormUtils.noneIfEmpty(name);
  if (name$1 !== undefined) {
    return name$1;
  }
  let unitType$1 = Stdlib_Option.map(unitType, DevelopmentSampleUnitType.label);
  if (unitType$1 !== undefined) {
    return unitType$1;
  } else {
    return "Untitled unit";
  }
}

function price(price$1, priceRange, minPrice, maxPrice) {
  if (priceRange) {
    if (minPrice !== undefined) {
      if (maxPrice !== undefined) {
        return Numeral.formatForPriceRange(minPrice) + ` - ` + Numeral.formatForPriceRange(maxPrice);
      } else {
        return `From ` + Numeral.formatForPriceRange(minPrice);
      }
    } else if (maxPrice !== undefined) {
      return `Up to ` + Numeral.formatForPriceRange(maxPrice);
    } else {
      return "No price set";
    }
  } else if (price$1 !== undefined) {
    return Numeral.formatPrice(price$1);
  } else {
    return "No price set";
  }
}

function rangeValue(minValue, maxValue, formatValue) {
  if (minValue === undefined) {
    if (maxValue !== undefined) {
      return `Up to ` + formatValue(Primitive_option.valFromOption(maxValue));
    } else {
      return;
    }
  }
  let minValue$1 = Primitive_option.valFromOption(minValue);
  if (maxValue === undefined) {
    return formatValue(minValue$1) + `+`;
  }
  let maxValue$1 = Primitive_option.valFromOption(maxValue);
  if (minValue$1 === maxValue$1) {
    return formatValue(minValue$1);
  } else {
    return formatValue(minValue$1) + `-` + formatValue(maxValue$1);
  }
}

function intRangeLabel(minValue, maxValue, singleSuffix, pluralSuffix) {
  return Stdlib_Option.map(rangeValue(minValue, maxValue, value => value.toString()), value => value + ` ` + (
    minValue !== undefined ? (
        minValue !== 1 || maxValue !== undefined && maxValue !== 1 ? pluralSuffix : singleSuffix
      ) : (
        maxValue === 1 ? singleSuffix : pluralSuffix
      )
  ));
}

function floatRangeLabel(minValue, maxValue, singleSuffix, pluralSuffix) {
  return Stdlib_Option.map(rangeValue(minValue, maxValue, NumberUtils.formatFloat), value => value + ` ` + (
    minValue !== undefined ? (
        minValue !== 1.0 || maxValue !== undefined && maxValue !== 1.0 ? pluralSuffix : singleSuffix
      ) : (
        maxValue === 1.0 ? singleSuffix : pluralSuffix
      )
  ));
}

function intLabel(value, singleSuffix, pluralSuffix) {
  return Stdlib_Option.map(value, value => value.toString() + ` ` + (
    value !== 1 ? pluralSuffix : singleSuffix
  ));
}

function floatLabel(value, singleSuffix, pluralSuffix) {
  return Stdlib_Option.map(value, value => NumberUtils.formatFloat(value) + ` ` + (
    value !== 1.0 ? pluralSuffix : singleSuffix
  ));
}

function details(bedsRange, beds, minBeds, maxBeds, bathsRange, baths, minBaths, maxBaths, squareFeetRange, squareFeet, minSquareFeet, maxSquareFeet) {
  let bedsDetail = bedsRange ? intRangeLabel(minBeds, maxBeds, "bd", "bd") : intLabel(beds, "bd", "bd");
  let bathsDetail = bathsRange ? floatRangeLabel(minBaths, maxBaths, "ba", "ba") : floatLabel(baths, "ba", "ba");
  let squareFeetDetail = squareFeetRange ? Stdlib_Option.map(rangeValue(minSquareFeet, maxSquareFeet, Numeral.formatNumber), value => value + ` sqft`) : Stdlib_Option.map(squareFeet, value => Numeral.formatNumber(value) + ` sqft`);
  let details$1 = [
    bedsDetail,
    bathsDetail,
    squareFeetDetail
  ];
  let details$2 = Stdlib_Array.keepSome(details$1);
  if (details$2.length !== 0) {
    return details$2.join(" • ");
  } else {
    return "No details set";
  }
}

function propertyAttributes(bedsRange, beds, minBeds, maxBeds, bathsRange, baths, minBaths, maxBaths, squareFeetRange, squareFeet, minSquareFeet, maxSquareFeet) {
  let bedsAttribute = bedsRange ? Stdlib_Option.map(rangeValue(minBeds, maxBeds, value => value.toString()), value => [
      value,
      minBeds !== undefined ? (
          minBeds !== 1 || maxBeds !== undefined && maxBeds !== 1 ? "Beds" : "Bed"
        ) : (
          maxBeds === 1 ? "Bed" : "Beds"
        )
    ]) : Stdlib_Option.map(beds, value => [
      value.toString(),
      value !== 1 ? "Beds" : "Bed"
    ]);
  let bathsAttribute = bathsRange ? Stdlib_Option.map(rangeValue(minBaths, maxBaths, NumberUtils.formatFloat), value => [
      value,
      minBaths !== undefined ? (
          minBaths !== 1.0 || maxBaths !== undefined && maxBaths !== 1.0 ? "Baths" : "Bath"
        ) : (
          maxBaths === 1.0 ? "Bath" : "Baths"
        )
    ]) : Stdlib_Option.map(baths, value => [
      NumberUtils.formatFloat(value),
      value !== 1.0 ? "Baths" : "Bath"
    ]);
  let squareFeetAttribute = squareFeetRange ? Stdlib_Option.map(rangeValue(minSquareFeet, maxSquareFeet, Numeral.formatNumber), value => [
      value,
      "Sqft"
    ]) : Stdlib_Option.map(squareFeet, value => [
      Numeral.formatNumber(value),
      "Sqft"
    ]);
  return Stdlib_List.filterMap({
    hd: bedsAttribute,
    tl: {
      hd: bathsAttribute,
      tl: {
        hd: squareFeetAttribute,
        tl: /* [] */0
      }
    }
  }, x => x);
}

exports.title = title;
exports.price = price;
exports.rangeValue = rangeValue;
exports.intRangeLabel = intRangeLabel;
exports.floatRangeLabel = floatRangeLabel;
exports.intLabel = intLabel;
exports.floatLabel = floatLabel;
exports.details = details;
exports.propertyAttributes = propertyAttributes;
/* Numeral Not a pure module */
